'use client';

import { Message } from '@/lib/copilot/message';
import classNames from 'classnames';
import { memo } from 'react';
import { MessageRow } from './MessageRow';
import { parse } from 'marked';
import { Body } from '@/components/wysiwyg/Body';
import { MessageActions } from './MessageUtils';


/**
 * Renders status messages in the chat interface
 */
function StatusMessageComponent({ message, isLast = false }: {
  message: Message;
  isLast?: boolean;
}) {
  return (
    <div className="flex flex-col gap-2 group relative">
      <div 
        aria-label="Status message"
        className={classNames(
          'border border-gray-400 bg-gray-300 text-orange-800 mr-auto',
          'p-4 rounded-lg w-fit',
          'flex flex-col gap-2'
        )}
        >
        <p className="sr-only">Status: </p>
        <Body value={parse(message.content ?? '', {async: false}) as string} />
      </div>
        <MessageActions message={message} isLast={isLast} />
    </div>
  );
}

export const StatusMessage = memo(StatusMessageComponent);